export default function CCreateFiles() {
  return <h2>C Create Files</h2>;
}
